import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const selectPermissionsState = createSelector([(state) => state.permissions], (permissions) => permissions ?? {});

export function usePermissions() {
  return useSelector(selectPermissionsState);
}
